import { RewardType } from './recognition.type';

export const REWARDS: Array<RewardType> = [
  {
    id: 1,
    label: 'Stickerpack',
    value: 'STICKER_PACK',
    actionLabel: 'TELEGRAM',
    link: 'https://telegram.org/',
  },
  {
    id: 2,
    label: 'Feedback',
    value: 'FEEDBACK_FORM',
    actionLabel: 'MICROSOFT FORMS',
    link: 'https://forms.office.com/',
  },
  {
    id: 3,
    label: 'Picture',
    value: 'PICTURE',
    actionLabel: '',
    link: '',
  },
];

export const LINK_LIMIT = 100;
